import {HSAdministeredDose, HSAdministeredDrug, HSDoseRound, HSPackedMedication} from "server-openapi";
import itiriri from "itiriri";

export interface RoundHierarchy {
    doseRound: HSDoseRound;
    administeredDose: HSAdministeredDose;
    administeredDrug: HSAdministeredDrug;
}
export function getRoundHierarchiesForPackedMedication(
    roundStore: ReadonlyMap<string, HSDoseRound>,
    packedMedication: HSPackedMedication
): RoundHierarchy[] {
    const result: RoundHierarchy[] = [];
    itiriri(roundStore.values()).forEach(round => {
        round.administeredDoses?.forEach(aDose => {
            if (aDose && aDose!.doseTimestamp === packedMedication.doseTimestamp) {
                aDose.administeredDrugs?.forEach(aDrug => {
                    if (aDrug.medicationId === packedMedication.medicationId) {
                        result.push({
                            doseRound: round,  
                            administeredDose: aDose,  
                            administeredDrug: aDrug
                        });
                    }
                });
            }
        });
    });
    return result;
}
export function getRoundHierarchyForAdministeredDrug(
    roundStore: ReadonlyMap<string, HSDoseRound>,
    administeredDrugClinicalSystemId?: string, 
    administeredDrugId?: number
): RoundHierarchy | undefined {
    var administeredDrug: HSAdministeredDrug | undefined = undefined;
    var administeredDose: HSAdministeredDose | undefined = undefined;
    var doseRound: HSDoseRound | undefined;
    itiriri(roundStore.values()).values().forEach(round => {
        round.administeredDoses?.forEach(aDose => {
            aDose.administeredDrugs?.forEach((aDrug) => {
                if ((!!administeredDrugClinicalSystemId && aDrug.clinicalSystemId === administeredDrugClinicalSystemId) || (!!administeredDrugId && aDrug.hsId === administeredDrugId)) {
                    doseRound  = round;
                    administeredDose = aDose;
                    administeredDrug = aDrug;
                    return;
                }
            });
        });
    });
    if (!administeredDrug) {
        return undefined;
    }
    return {
        doseRound: doseRound!,
        administeredDose: administeredDose!,
        administeredDrug: administeredDrug!
    };
}

